<template>
  <section class="block-flash" :class="[background]">
    <div class="block-flash">
      <div class="block-flash__content">
        <div
          v-if="block.heading"
          class="block-flash__content__heading"
          :class="{ increase: block.options.increaseHeadingSize }"
        >
          <h3>{{ block.heading }}</h3>
        </div>
        <div class="block-flash__content__item">
          <div v-html="block.body"></div>
        </div>
        <div
          class="block-flash__content__cta"
          v-for="(item, index) in block.ctaGroup"
          :key="`cta-${index}`"
        >
          <CtaItem
            :label="item.label"
            :link="`${item.link}`"
            :colour="item.colour"
            :position="item.position"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { background } from '@/mixins';
import CtaItem from '@/components/Cta/CtaItem';

export default {
  name: 'BlockFlash',
  components: {
    CtaItem
  },
  props: {
    block: [Array, Object]
  },
  mixins: [background],
  computed: {}
};
</script>

<style lang="postcss">
.block-flash {
  @apply flex flex-wrap;
  width: 100%;
  &.bg-brand-green,
  &.bg-brand-darkerBlue {
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      @apply text-white;
    }
  }
  &.bg-brand-grey {
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      @apply text-brand-darkerBlue;
    }
  }
  &.bg-brand-black {
    h2,
    h3,
    h4,
    h5,
    h6,
    a,
    p {
      @apply text-white;
    }
  }
  &__container {
    @apply flex flex-col justify-center items-center;
    @apply mx-auto;
    @apply pt-32 pb-24;
    @apply z-40;
    @screen sm {
      @apply py-32;
    }
  }
  &__content {
    @apply w-9/10;
    @apply text-center;
    @apply text-white;
    @apply pt-64 pb-48;
    @apply flex align-middle justify-center flex-col;
    margin: 0 auto;
    h2 {
      @apply font-ginto-black;
      @apply mb-40;
      font-size: calc(20px + (40 - 20) * (100vw - 640px) / (1920 - 640));
      @apply leading-snug;
      &:last-of-type {
        @apply mb-0;
      }
    }
    h3 {
      @apply font-ginto-black;

      font-size: calc(20px + (36 - 20) * (100vw - 640px) / (1920 - 640));
      @apply leading-snug;
    }
    h4 {
      @apply font-ginto-black;
      font-size: calc(20px + (36 - 20) * (100vw - 640px) / (1920 - 640));
      @apply leading-snug;
      @apply pb-8;
      @screen sm {
        @apply pb-16;
      }
      &:last-of-type {
        @screen sm {
          @apply pb-0;
        }
      }
    }
    h5 {
      @apply pb-16;
      font-size: calc(14px + (20 - 14) * (100vw - 640px) / (1920 - 640));
      &:last-of-type {
        @apply pb-0;
      }
    }
    h6 {
      font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
      @apply max-w-3xl;
      @apply mx-auto;
    }
    p {
      @apply font-ginto-regular;
      @apply pb-8;
      @apply leading-snug;
      font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
      strong {
        @apply font-ginto-bold;
      }
      &:last-of-type {
        @apply pb-0;
      }
      @screen sm {
        @apply pb-8;
      }
    }
    &__heading {
      h3 {
        @apply text-center;
        font-size: calc(16px + (26 - 16) * (100vw - 640px) / (1920 - 640));
        @apply mb-0;
      }
      &.increase {
        h3 {
          font-size: calc(28px + (56 - 28) * (100vw - 640px) / (1920 - 640));
          @apply mb-16;
        }
      }
    }
    &__item {
      @apply flex;

      &:last-of-type {
        @apply pb-0;
      }
      .left {
        @apply text-left;
      }
      .center {
        @apply text-center;
      }
      .right {
        @apply text-right;
      }
      .offset {
        @apply max-w-md;
        @screen sm {
          @apply max-w-screen-sm;
        }
      }
    }
    &__cta {
      @apply flex flex-col items-center;
      @apply pt-16;
      @screen sm {
        @apply pt-16;
      }
    }
    @screen sm {
      @apply max-w-screen-lg;
    }
  }
  &__media {
    @screen sm {
      @apply h-screen;
      @apply w-1/2;
    }
    img {
      @apply object-cover;
      @apply h-full;
    }
  }
  &.with-image {
    @apply min-h-screen;
    @screen sm {
      @apply h-auto;
    }
    .block-flash__container {
      @screen sm {
        @apply w-1/2;
        @apply max-w-screen-md;
      }
    }
  }
  &.remove-spacing {
    .block-flash__container {
      @apply pt-0;
    }
  }
}
</style>
